module.exports = __webpack_public_path__ + "img/attendance-success.aeb9383.png";